import { SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { TextField } from '@material-ui/core';

export const RejectDraw = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore } = useDrawsStore();

  const { drawActionsStore } = drawStore;

  const onSendRejectionReason = async () => {
    await drawActionsStore.sendRejectionReason(drawId, afterActionExecuted);
  }

  return (
    <SubmitDialog
      title="Reject Draw"
      open={drawActionsStore.isRejectDrawDialogOpen}
      body={
        <TextField
          variant="outlined"
          label="Please enter the reason you are rejecting this draw"
          value={drawActionsStore.rejectReason}
          onChange={(e) => drawActionsStore.setRejectReason(e.target.value)}
          multiline
          rows={3}
          margin="normal"
          fullWidth
          style={{ background: 'white' }}
        />
      }
      handleClose={() => drawActionsStore.setIsRejectDrawDialogOpen(false)}
      handleOk={onSendRejectionReason}
      cancelButtonText='Cancel'
    />
  );
});
